<template lang="pug">
  v-card.table-x__row
    .table-x__row-inner
      .table-x__row-col {{ item.name }}
      .table-x__row-col {{ item.daily_feed_intake | floor }}
      .table-x__row-col {{ item.total_amount | floor }}
      .table-x__row-col {{ item.plan_weight | floor }} / {{ item.fact_weight | floor }}
      .table-x__row-col {{ item.planned_on | date }}
      .table-x__row-col
        status-label(
          :status="item.status")
      .table-x__row-actions
        v-switch.mr-1(
          :disabled="isConsultant"
          v-show="!item.deleted"
          v-model="item.is_active"
          @input="updateCurrentRow")
        v-btn(
          v-show="!item.deleted"
          :disabled="isConsultant"
          icon
          small
          @click="setCurrentSchedule(item)")
          v-icon(
            icon="cog"
            font-size="1.1")
        v-toggler(v-model="toggled")
    template(v-if="toggled")
      v-divider(thin)
      .table-x__row-inner.mt-1
        h2.card-title {{ item.schedule_animalfeed_recipe.name }}
      table.table
        thead.table__header
          tr.table__row.table__row--head
            th.table__cell {{ 'base.ingredient' | translate }}
            th.table__cell {{ 'base.count_for_mix' | translate }}
            th.table__cell {{ 'base.price' | translate }}
            th.table__cell {{ 'base.mix_time_on_ton' | translate }}
              
        tbody.table__body
          tr.table__row(
            v-for="(ingredient, index) in item.schedule_animalfeed_recipe.schedule_ingredients"
            :key="index")
            td.table__cell {{ ingredient.name }}
            td.table__cell {{ ingredient.plan_weight | floor }} / {{ ingredient.fact_weight | floor }}
            td.table__cell {{ ingredient.fact_price | floor }}
            template(v-if="index === 0")
              td.table__cell.table__cell--thin
                ui-number-input(
                  v-if="item.status === 'waited'"
                  :blocked="item.deleted"
                  :hideControls="item.deleted"
                  :label="'base.mix_time' | translate"
                  :postfix="' ' + $t('base.min')"
                  v-model="item.mix_time"
                  @input="updateCurrentRow")
            template(v-else)
              td.table__cell
</template>

<script>
import { mapActions } from 'vuex'

import UiNumberInput from '@/components/ui/ui-number-input/UiNumberInput'
import StatusLabel from '../../planning/list/item-parts/StatusLabel'

export default {
  name: 'PlanningTableRow',

  components: {
    UiNumberInput,
    StatusLabel
  },

  props: {
    item: Object
  },

  data: () => ({
    toggled: false
  }),

  methods: {
    ...mapActions('animalfeed', [
      'setCurrentSchedule',
      'updateSchedule'
    ]),

    updateCurrentRow () {
      this.updateSchedule({
        id: this.item.id,
        payload: this.item
      })
    }
  }
}
</script>
